import { useCallback } from 'react';
import useTracking from './use-tracking';
import { getAssignmentFlowDurationMs } from './assignment-flow';

export default function useAssignmentFlowTracking(type) {
  const { trackAssignmentConfirmed } = useTracking();

  const confirm = useCallback(
    (details) => {
      trackAssignmentConfirmed({
        type,
        ...details,
        durationMs: getAssignmentFlowDurationMs()
      });
    },
    [trackAssignmentConfirmed, type]
  );

  return { confirm };
}



// WEBPACK FOOTER //
// ./analytics/tracking/use-assignment-flow-tracking.js